export const THIRD_PARTY_BILLING_LIST = "THIRD_PARTY_BILLING_LIST";

export default (state = null, action) => {
    switch (action.type) {
        case THIRD_PARTY_BILLING_LIST:
            return action.payload;
        default:
            return state;
    }
}
